// src/context/errors/ErrorBoundary.js
import React from 'react';
import { handleError } from './errorUtils';
import { sendLogToServer } from '../../utils/log';

class ErrorBoundary extends React.Component {
  state = { error: null, stack: null };

  static getDerivedStateFromError(error) {
    return { error: error.message, stack: error.stack };
  }

  componentDidCatch(error, errorInfo) {
    const context = {
      componentStack: errorInfo.componentStack,
      action: 'error_boundary',
      ...(this.props.context || {}),
    };

    handleError({
      code: 'RENDERING_ERROR',
      error,
      context,
    });

    sendLogToServer('error', 'Ошибка рендеринга в ErrorBoundary', {
      message: error.message,
      stack: error.stack,
      ...context,
    });
  }

  render() {
    if (this.state.error) {
      return (
        <div style={{ padding: '20px', color: 'red' }}>
          <h2>Произошла ошибка</h2>
          <p>{this.state.error}</p>
          <pre>{this.state.stack}</pre>
          {this.props.onBack && (
            <button onClick={this.props.onBack}>Вернуться</button>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;